module.exports = __webpack_public_path__ + "static/media/summary-default.f60fe964.svg";